import Web3 from 'web3'

const getWeb3 = () =>
  new Promise(async (resolve, reject) => {
    if (window.ethereum) {
      const networkId = process.env.REACT_APP_NETWORK_ID
      if (networkId == "97" || networkId == "56") {
        const data = networkId === "56" ? [{
          chainId: '0x38',
          chainName: 'Binance Smart Chain',
          nativeCurrency:
          {
            name: 'BNB',
            symbol: 'BNB',
            decimals: 18
          },
          rpcUrls: ['https://bsc-dataseed.binance.org/'],
          blockExplorerUrls: ['https://bscscan.com/'],
        }] : [{
          chainId: '0x61',
          chainName: 'Binance Smart Chain - Testnet',
          nativeCurrency:
          {
            name: 'BNB',
            symbol: 'BNB',
            decimals: 18
          },
          rpcUrls: ['https://data-seed-prebsc-2-s1.binance.org:8545'],
          blockExplorerUrls: ['https://testnet.bscscan.com'],
        }]
        await window.ethereum.request({
          method: 'wallet_addEthereumChain',
          params: data
        }).then(() => {
          setTimeout(async () =>{
            try {
              const web3 = new Web3(window.ethereum)
              await window.ethereum.request({ method: 'eth_requestAccounts' })
              window.ethereum.on('accountsChanged', (accounts) => {
                window.location.reload()
              })

              window.ethereum.on('chainChanged', (chainId) => {
                window.location.reload()
              })
              resolve(web3)
            } catch (error) {
              reject(error)
            }
          }, 1000);
        }).catch(e =>
          reject(e)
        )
      } else {
        try {
          const web3 = new Web3(window.ethereum)
          await window.ethereum.request({ method: 'eth_requestAccounts' })
          window.ethereum.on('accountsChanged', (accounts) => {
            window.location.reload()
          })

          window.ethereum.on('chainChanged', (chainId) => {
            window.location.reload()
          })
          resolve(web3)
        } catch (error) {
          reject(error)
        }
      }
    } else if (window.web3) {
      const web3 = window.web3
      console.log('Injected web3 detected.')
      resolve(web3)
    } else {
      const provider = new Web3.providers.HttpProvider('http://127.0.0.1:8545')
      const web3 = new Web3(provider)
      console.log('No web3 instance injected, using Local web3.')
      resolve(web3)
    }
  })

export default getWeb3
